import Edit16 from '@carbon/icons-react/es/edit/16';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

const MenuItem = styled(Menu.Item)`
  span {
    flex: 1;
  }
`;

const BaseEdit: FC<React.PropsWithChildren<MenuItemProps>> = (params) => {
  const { icon = <Edit16 />, children } = params;

  return (
    <MenuItem icon={icon} {...params}>
      {children || <FormattedMessage id="edit" />}
    </MenuItem>
  );
};

export const Edit = withHideIfNotAllowed(BaseEdit);
